import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppletBadgeContainerModel } from '../../../../../../models/aggregates/applet/badge';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';

@Injectable({providedIn: 'root'})

export class AppletBadgeService extends BaseApiTemplateService<AppletBadgeContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'applet-badges';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + Core2Config.APPLET_PREFIX + 'applet-badges';
    this.httpClient = http;
  }

  deletePermanent(badgeGuid: string, visa: ApiVisa): Observable<ApiResponseModel<AppletBadgeContainerModel>> {
    let url = this.apiUrl + '/permanent/' + badgeGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/permanent/' + badgeGuid;
    }
    return this.httpClient.delete<ApiResponseModel<AppletBadgeContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  deleteMyBadgesByAppletLoginSubject(appletLoginSubjectLinkGuid: string, visa: ApiVisa): Observable<ApiResponseModel<AppletBadgeContainerModel>> {
    let url = this.apiUrl + '/delete-my-badges/by-applet-login-subject/' + appletLoginSubjectLinkGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/delete-my-badges/by-applet-login-subject/' + appletLoginSubjectLinkGuid;
    }
    return this.httpClient.delete<ApiResponseModel<AppletBadgeContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  deleteMyBadgeByGuid(guid: string, visa: ApiVisa): Observable<ApiResponseModel<AppletBadgeContainerModel>> {
    let url = this.apiUrl + '/delete-my-badge/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/delete-my-badge/' + guid;
    }
    return this.httpClient.delete<ApiResponseModel<AppletBadgeContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  deleteAllMyBadges(visa: ApiVisa): Observable<ApiResponseModel<number>> {
    let url = this.apiUrl + '/delete-my-badges';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/delete-my-badges';
    }
    return this.httpClient.delete<ApiResponseModel<number>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getMyBadgesByCriteria(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<AppletBadgeContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/get-my-badges?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<AppletBadgeContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  getMyBadgesByAppletLoginSubject(appletLoginSubjectLinkGuid: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<AppletBadgeContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/get-my-badges/by-applet-login-subject/' + appletLoginSubjectLinkGuid + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<AppletBadgeContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
